module.exports = __webpack_public_path__ + "i18n/zh-TW.c3046b576af46561611ac6c938657f7f.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 858
// module chunks = 60